const routes = {
  '/app/history': {
    fetch: () =>
      import(
        /* webpackChunkName: 'history-route' */ 'app/history/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
